import {Subject} from "rxjs/index";

const langSubject = new Subject();

export const langService = {
  setLang: lang => langSubject.next({lang}),
  getLang: () => langSubject.asObservable()
};

const frameRequestSubject = new Subject();

export const frameRequestService = {
  setFrame: frame => frameRequestSubject.next({frame}),
  getFrame: () => frameRequestSubject.asObservable()
};
